import React, { createRef, useEffect, useState } from "react";

import { s360ConfigService } from "../Services/S360Config";

import CheckBox from "./CheckBox";
import DropDown from "./DropDown";
import InitialFormHeader from "./InitialFormHeader";
import RadioButton from "./RadioButton";
import TextBox from "./TextBox";

import './InitialFormStyleSheet.css';

function InitialFormDetails(props) {
  const [components, setComponents] = useState([]);
  const [count] = useState(0);
  const [allowSubmit, setSAllowSubmit] = useState(false);
  const modifyLoginButton = (data) => {
    setSAllowSubmit(data)
  }
  useEffect(() => {
    const items = s360ConfigService.config && s360ConfigService.config.form
      ? s360ConfigService.config.form.sort((i1, i2) => i1.selposition - i2.selposition)
      : [];

    setComponents(
      items.map((item, index) => {
        const ref = createRef();
        if (item.seltype === "checkBox") {
          return { item, ref, component: <CheckBox idxx={'chh' + index} ref={ref} item={item} key={item.selposition} /> }
        } else if (item.seltype === "dropDown") {
          return { item, ref, component: <DropDown idxx={'ch' + index} ref={ref} item={item} key={item.selposition} /> }
        } else if (item.seltype === "radioButton") {
          return { item, ref, component: <RadioButton ref={ref} item={item} key={item.selposition} /> }
        } else {
          return { item, ref, component: <TextBox idxx={`txt${index}`} {...props} index={index} ref={ref} item={item} key={item.selposition} count={count} modifyLoginButton={modifyLoginButton} /> }
        }
      })
    )
  }, [s360ConfigService?.config]);



  const startChat = () => {


    // let invalidOptions = components.filter(component => component.ref.current.validate());
    // const isValid = !!invalidOptions.length === 0;
    // console.log(invalidOptions,"isValid")

    let params = {};
    components.forEach(component => params = { ...params, ...component.ref.current.value() });

    props.actions.startChat(params);

  }

  // Sort form items by selposition.
  return (
    <>
      <InitialFormHeader {...props} />
      <div className="s360-initial-form-details-container" style={props.config?.customDesign?.initialFormDetailsContainer}>
        <div className="s360-initial-form-details-inputs">
          {components.map((component) => <>{component.component}</>)}
        </div>
        <div className="s360-initial-form-start-button-container">
          <button className="s360-initial-form-start-button"
            onClick={allowSubmit ? startChat : console.log("Form Invalid")}
            style={{ ...s360ConfigService.config?.customDesign?.initialFormStartButton }}
            disabled={!allowSubmit}>
            <span className="s360-initial-form-start-button-span-text">{props.config.configDetails?.formButtonText}</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default InitialFormDetails;
